export const tempuserGuid = "a000000000000000000000000000000a";
export const DEFAULT_CHARACTER_LIMIT = 1000;
export const PAID_USER_CHARACTER_LIMIT = 20000;

export const musicEventSubType = {
  Generate: "AI.Music.Request.Generate",
  SeparateStems: "AI.Music.Request.SeparateStems",
} as const;

export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

export const DomainName = {
  PDFSIMPLI: "pdfsimpli",
  RESUMEBUILD: "resumebuild",
  LEGALSIMPLI: "legalsimpli",
  SIGNSIMPLI: "signsimpli",
  WORKSIMPLI: "worksimpli",
  SECURESIMPLI: "securesimpli",
};

export const CategoryName = {
  SUMMARIZER_AI: "writesimpli-summarizer-ai",
  DETECTOR_AI: "writesimpli-detector-ai",
  PLAGIARISM_AI: "writesimpli-plagiarism-ai",
  CITATIONS_AI: "writesimpli-citations-ai",
  COMPARE_AI: "writesimpli-compare-ai", 
  GRAMMAR_AI: "writesimpli-grammar-ai",
  IMAGE_DETECTOR_AI: "writesimpli-ai-image-detector",
  MUSIC_GENERATOR_AI :"music-generator-ai",
};

/** Dashboard operation-limit keys (backend config identity). */
export const OperationLimitKey = {
  MUSIC_GENERATOR_AI: "MUSIC_GENERATOR_AI",
} as const;

// TODO: Confirm these status codes
export const JobStatus = {
  ENQUEUED: 10,
  IN_PROGRESS: 20,   // TODO: Confirm this value
  SUCCESS: 30,       // TODO: Confirm this value
  FAILED: 40,        // TODO: Confirm this value
} as const;

// TODO: Confirm what jobTitle should represent for each operation type
export const JobTitle = {
  SUMMARIZER: 1,
  AI_DETECTOR: 2,
  PLAGIARISM: 3,
  GRAMMAR: 4,
  CITATIONS: 5,
  COMPARE: 6,
  AI_IMAGE_DETECTOR: 7,
  MUSIC_GENERATOR: 8,
} as const;

/** Wait before the first upload-status API check after stream starts (ms). */
export const STATUS_POLL_INITIAL_DELAY_MS = 5000;

/** Doc-operation API enums (from WorkSimpli login/document-helper). */
export const DocOperationType = {
  CONVERT: 40,
} as const;

export const DocOperationFileType: Record<string, number> = {
  mp3: 110,
  wav: 108,
  m4a: 119,
  opus: 200,
  flac: 118,
};
